import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { UPLOAD_LIMIT } from '../../../../utils/constants';
import { showErrorToast } from '../../../../utils/util';

import './file-picker.scss';

const FilePicker = ({ triggerElement, fileType, fileRef, onChange, enableFileLimit }) => {
  const dispatch = useDispatch();
  const handleOnchange = (event) => {
    if (enableFileLimit) {
      const file = event?.target?.files[0];
      if (!file) {
        return;
      }

      if (file.size > UPLOAD_LIMIT * 1000 * 1024) {
        showErrorToast(dispatch, `File size cannot be more than ${UPLOAD_LIMIT} MB`);
        return;
      }
    }
    onChange(event);
  };
  return (
    <div className="file-picker">
      {triggerElement}
      <input
        accept={fileType}
        type="file"
        ref={fileRef}
        value={''}
        onChange={handleOnchange}
        data-testid="file-picker"
      />
    </div>
  );
};

FilePicker.propTypes = {
  triggerElement: PropTypes.node.isRequired,
  fileType: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  fileRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })])
    .isRequired,
  onChange: PropTypes.func.isRequired,
};

FilePicker.defaultProps = {
  fileType: '*',
};

export default FilePicker;
